// eslint-disable-next-line
// @ts-nocheck
import { soap } from '../../core/Soap';
import { alertSoapError } from '../../core/SessionSoap';
import { jsonToXml } from '../../core/XmlToJson';

const saveTOC = async (state, tocData): Promise<boolean> => {
	const { changes, selectedSortingType, sortingType } = state;
	const propsToSkip = new Set([
		'@aras.action',
		'@odata.type',
		'role@aras.keyed_name'
	]);
	const propsToStringify = new Set(['sort_order', 'additional_data']);
	const mlPropNamePrefix = '@aras.lang.';

	const order = new Map([
		['add-#CommandBarMenu', 1],
		['add', 2], // menubutton, button and other
		['add-#CommandBarSectionItem', 3],
		['edit-#CommandBarMenu', 4],
		['edit', 5],
		['edit-#CommandBarSectionItem', 6],
		['delete-#CommandBarSectionItem', 7],
		['delete', 8],
		['delete-#CommandBarMenu', 9]
	]);

	const getItemOrder = (item) => {
		const { '@aras.action': action, '@odata.type': type } = item;
		return order.get(`${action}-${type}`) || order.get(`${action}`) || 0;
	};

	const getParentId = (id) => {
		const item = tocData.get(id);
		if (item['@aras.action'] !== 'delete') {
			return item['parent_menu@aras.id'];
		}

		const originalItem = tocData.get(id);
		return originalItem['parent_menu@aras.id'];
	};

	const getNestingDistance = (fromId: string, toParentId: string): number => {
		let nestingLevel = 0;
		let parentId = getParentId(fromId);

		while (parentId) {
			nestingLevel++;
			if (parentId === toParentId) {
				return nestingLevel;
			}

			parentId = getParentId(parentId);
		}

		return 0;
	};
	const changeEntries = Object.entries(changes);
	const sortedChanges = changeEntries.sort(([id1], [id2]) => {
		const item1 = tocData.get(id1);
		const item2 = tocData.get(id2);
		const order1 = getItemOrder(item1);
		const order2 = getItemOrder(item2);
		if (order1 !== order2) {
			return order1 - order2;
		}

		const { '@aras.action': action1, '@odata.type': type1 } = item1;
		const { '@aras.action': action2, '@odata.type': type2 } = item2;
		const actions = ['add', 'delete'];
		if (
			type1 === '#CommandBarMenu' &&
			type2 === '#CommandBarMenu' &&
			actions.includes(action1) &&
			actions.includes(action2)
		) {
			// item1 is a child of item2-then item2 should be added before item1 when the action is "add" and otherwise when the action is "delete"
			if (getNestingDistance(id1, id2) > 0) {
				return action1 === 'add' ? 1 : -1;
			}
			if (getNestingDistance(id2, id1) > 0) {
				return action1 === 'add' ? -1 : 1;
			}
		}

		return 0;
	});

	const amlItems = sortedChanges.map(([id, change]) => {
		const item = tocData.get(id);
		const odataType = item?.['@odata.type'];
		const type = odataType?.substring(1);
		const properties = {};
		const action = change['@aras.action'];
		if (action !== 'delete') {
			for (const [propName, propValue] of Object.entries(change)) {
				if (propsToSkip.has(propName)) {
					continue;
				}

				let value = propValue;
				if (value === undefined) {
					value = '';
				}

				if (propsToStringify.has(propName)) {
					value = JSON.stringify(value);
				}

				if (!propName.includes(mlPropNamePrefix)) {
					const realPropName = propName.replace('@aras.id', '');
					properties[realPropName] = value;
					continue;
				}

				const [prop, lang] = propName.split(mlPropNamePrefix);
				const mlPropName = `i18n:${prop}`;
				const newValue = {
					'@attrs': {
						'xml:lang': lang,
						'xmlns:i18n': 'http://www.aras.com/I18N'
					},
					'@value': value
				};
				const multilingualProperties = properties[mlPropName] || [];
				multilingualProperties.push(newValue);
				properties[mlPropName] = multilingualProperties;
			}
		}

		const itemObject = {
			Item: {
				'@attrs': {
					action,
					id,
					type,
					doGetItem: '0'
				},
				...properties
			}
		};

		return jsonToXml(itemObject);
	});

	let preferencesXml = '';
	if (sortingType !== selectedSortingType) {
		const Relationships = {
			Item: {
				'@attrs': {
					action: 'edit',
					id: 'DB4652A5C55D4EB38F39E5C0602CEC48',
					type: 'Core_GlobalLayout'
				},
				core_toc_sorting_type: selectedSortingType
			}
		};
		const itemObject = {
			Item: {
				'@attrs': {
					action: 'edit',
					id: '507A16AA36F94513AD7EC1F948B5B48F',
					type: 'Preference'
				},
				Relationships
			}
		};

		preferencesXml = jsonToXml(itemObject);
	}

	const requestToRefreshMetadataDate =
		'<Item type="CommandBarSection" id="0AEAF671F8E548C494CCEC8E13F99562" action="edit" doGetItem="0" />';
	const requestXml = `
			<Item type="Method" action="cui_toc_editor_save">
				<Relationships>
					${amlItems.join('')}${preferencesXml}${requestToRefreshMetadataDate}
				</Relationships>
			</Item>`;
	const requestOptions = { method: 'ApplyItem', async: true };

	aras.browserHelper.toggleSpinner(document, true, 'toc_editor_spinner');

	try {
		await soap(requestXml, requestOptions);
	} catch (err) {
		alertSoapError(err);
		return false;
	} finally {
		aras.browserHelper.toggleSpinner(document, false, 'toc_editor_spinner');
	}

	return true;
};

export default saveTOC;
